$(() => {
  const productForm = $('[data-product-form]');
  const addToCartButton = $('#js-add-to-cart-button');
  const addToCartButtonText = $('#js-add-to-cart-button-text');
  const addToCartButtonSpinner = $('#js-add-to-cart-button-spinner');

  const relatedForm = $('#js-product-add-related-form');
  const relatedFormAddCartButton = $("#js-product-add-related-cart-button");
  const relatedFormAddCartButtonText = $('#js-product-add-related-cart-button-text');
  const relatedFormAddCartButtonSpinner = $('#js-product-add-related-cart-button-spinner');

  const cartCountBubble = $('[data-cart-count-bubble]');
  const cartCount = $('[data-cart-count]');
  const cartPopup = $('.cart_popup');
  const cartPopupCloseButton = $('#js-cart-popup-close-button');
  const cartPopupProductList = $('#js-cart-popup-product-list');
  const cartPopupItemCount = $('#js-cart-popup-item-count');

  const adaptorVariantId = '37833126969494';
  const enrgVariantIdMap = {
    "42629582160022" : "42629582323862",  // e-NRG 10L(アダプターなし:アダプターあり)
    "42629582192790" : "42629582356630",  // e-NRG 20L(アダプターなし:アダプターあり)
    "42629582225558" : "42629582389398",  // e-NRG 40L(アダプターなし:アダプターあり)
    "42629582258326" : "42629582422166",  // e-NRG 60L(アダプターなし:アダプターあり)
    "42629582291094" : "42629582454934"   // e-NRG 80L(アダプターなし:アダプターあり)
  };

  // キャンペーン時にGlass Top Sをギフトする商品ID
  const glassTopSGiftVariantIds = [
    '42700361040022', // Vertigo 40 / Natural
    '42700361105558', // Vertigo 40 / Graphite
    '42700361171094', // Vertigo 40 / Bone
    '44164498948246', // Chaser 38 / Graphite
    '44164498915478', // Chaser 38 / Bone
    '44164498981014'  // Chaser 38 / Natural
  ];

  const glassTopVariantId = '42795887132822';
  const glassTopSVariantId = '45775223750806';

  function hideCartPopup () {
    cartPopup.addClass('cart_popup_hide');
  }
  function showCartPopup () {
    cartPopup.removeClass('cart_popup_hide');
  }

  function updateCartItemCount (cartItemCount) {
    // カートアイコン 個数更新
    cartCountBubble.removeClass('p-header__cart-count--hidden');
    cartCount.text(cartItemCount);
    // カートドロワー 個数更新
    cartPopupItemCount.text(cartItemCount);
  }

  function getSizedImageUrl(src, size) {
    let match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );
    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
    }
    return null;
  }

  function updateCartPopupContent (items) {
    let productList = '';
    items.forEach(item => {
      // 商品オプション一覧DOM
      let optionList = '';
      if (!item.product_has_only_default_variant) {
        optionListElements = '';
        item.options_with_values.forEach(option_with_value => {
          optionListElements += `<li class="cart_popup_product_list_item_detail_option_list_item">${ option_with_value.name } : ${ option_with_value.value }</li>`
        })
        optionList = `<ul class="cart_popup_product_list_item_detail_option_list">${ optionListElements }</ul>`
      }
      // 商品DOM
      let imageUrl = getSizedImageUrl(item.featured_image.url, '200x');
      productList += `
        <li class="cart_popup_product_list_item js-cart-popup-product-list-item" id="js-cart-popup-product-list-item-${ item.id }">
          <div class="cart_popup_product_list_item_left_wrapper">
            <img src=${ imageUrl } alt="${ item.featured_image.alt }" class="cart_popup_product_list_item_image">
            <div class="cart_popup_product_list_item_detail">
              <h3 class="cart_popup_product_list_item_detail_title">${ item.product_title }</h3>
              ${ optionList }
            </div>
          </div>
          <input
            type="image"
            value="${ item.key }"
            data-variantid="${ item.id }"
            class="cart_popup_product_list_item_delete_button"
            src="https://cdn.shopify.com/s/files/1/0430/4961/5510/files/EcoSmart_Fire_cartpopup_close.svg?v=1658206623">
        </li>
      `
    });
    cartPopupProductList.html(productList);
  }

  function decrementItemInCartPopup (lineItemKey, variantID) {
    $.getJSON('/cart.js')
      .done((cart) => {
        const variantIDList = [];
        const updates = {};
        const campaignProductId = document.querySelector('input[name="campaign_product_id"]')?.value || ""
        let isCampaign = false;
        cart.items.forEach(item => {
          if (item.key === lineItemKey) {
            updates[item.key] = (item.quantity - 1 >= 0) ? (item.quantity - 1) : 0;
            if (item.product_id == campaignProductId) {
              isCampaign = true;
            }
            variantIDList.push(item.variant_id);
          }
        });
        if (isCampaign) {
          cart.items.forEach(item => {
            if (item.title && item.title.includes('キャンペーン特典')) {
              updates[item.key] = (item.quantity - 1 >= 0) ? (item.quantity - 1) : 0;
              variantIDList.push(item.variant_id);
            }
          });
        }
        if (Object.keys(updates).length === 0) {
          return;
        }
        $.ajax({
          url: window.Shopify.routes.root + 'cart/update.js',
          method: 'POST',
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          data: JSON.stringify({ updates }),
        })
        .done((cartState) => {
          updateCartItemCount(cartState.item_count);
          variantIDList.forEach(variantID => {
            $(`#js-cart-popup-product-list-item-${ variantID }`).remove();
          });
          // 表示商品がなくなった場合はドロワーを非表示にする
          if ($('.js-cart-popup-product-list-item').length === 0) {
            hideCartPopup();
          }
        });
      })
  }

  function handleButtonLoadingState (isLoading, buttonText, buttonSpinner, buttonElement) {
    if (isLoading) {
      buttonText.hide();
      buttonSpinner.show();
      buttonElement.attr('disabled', true);
    } else {
      buttonText.show();
      buttonSpinner.hide();
      buttonElement.attr('disabled', false);
    }
  }

  function handleAddToCartButtonLoadingState (isLoading) {
    handleButtonLoadingState(isLoading, addToCartButtonText, addToCartButtonSpinner, addToCartButton)
  }

  function handleRelatedFormAddCartButtonLoadingState (isLoading) {
    handleButtonLoadingState(isLoading, relatedFormAddCartButtonText, relatedFormAddCartButtonSpinner, relatedFormAddCartButton)
  }

  function addItemsToCart (data) {
    hideCartPopup();
    let params = {
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    }
    $.post(params)
      .done((data) => {
        $.getJSON('/cart.js')
          .done((cart) => {
            updateCartItemCount(cart.item_count);
            // 本商品か関連商品かに応じて`data`の形式が異なる。
            // 本商品: data = {'id': 999, ...}
            // 関連商品: data = {'items': [{'id': 999, ...}, ...]}
            if ('items' in data) {
              updateCartPopupContent(data.items);
            } else {
              updateCartPopupContent([data]);
            }
            showCartPopup();

            // 削除ボタン
            let cartPopupDecrementButtons = $('.cart_popup_product_list_item_delete_button');
            cartPopupDecrementButtons.on('click', function () {
              decrementItemInCartPopup(this.value, $(this).data('variantid'))
            })
          })
      })
      .fail((response) => {
        console.log(response);
      })
      .always(() => {
        handleAddToCartButtonLoadingState(false);
        handleRelatedFormAddCartButtonLoadingState(false);
      })
  }

  // 本商品 カート追加ボタンが押された時
  productForm.submit(function (event) {
    let items = [];
    event.preventDefault();
    handleAddToCartButtonLoadingState(true);
  
    // 修正ポイント：serializeArray()を使う
    const data = $(this).serializeArray();
    const variantId = data.find((p) => p.name === 'id');
    let relatedFormCheckedCheckboxes = $('input[name=related-product]:checked');
    let isEnrgPlusAdaptor = false;
    if (variantId) {
      // e-NRGとadaptorを同時に購入した場合は、e-NRGのadaptor付きバリエーションに変更する
      relatedFormCheckedCheckboxes.each((_, checkbox) => {
        if (checkbox.value == adaptorVariantId && enrgVariantIdMap[variantId.value]) {
          isEnrgPlusAdaptor = true;
        }
      });
      items.push({ id: isEnrgPlusAdaptor ? enrgVariantIdMap[variantId.value] : variantId.value });
    }
  
    // 合わせて購入
    relatedFormCheckedCheckboxes.each((_, checkbox) => {
      // e-NRGとadaptorを同時に購入した場合は、e-NRGのadaptor付きバリエーションに変更したため、関連商品では追加しない
      if (isEnrgPlusAdaptor && checkbox.value == adaptorVariantId) {
        return true;
      }    
      items.push({ id: checkbox.value });
    });
  
    // console.log(items);
    addItemsToCart({ items: items });
  });  

  // 合わせて購入 カート追加ボタンが押された時
  relatedForm.submit(function (event) {
    let items = [];
    event.preventDefault();
    handleRelatedFormAddCartButtonLoadingState(true);
    
    // メインの商品を取得
    // パラメーターにvariantがあるときはパラメーターのvariantを優先
    // なければ初期のvariantIdを取得してかーとに入れる
    let url = new URL(window.location.href);
    let param = url.searchParams.get('variant');
    let variantIdValue = '';
    if (param) {
      items.push({'id': param});
      variantIdValue = param;
    } else {
      const data = $(productForm).serializeArray();
      const variantId = data.find((p) => p.name == 'id')
      if (variantId) {
        items.push({id: variantId.value})
        variantIdValue = variantId.value;
      }
    }
    const isGiftGlassTopS = glassTopSGiftVariantIds.includes(variantIdValue);

    // 合わせて購入
    let relatedFormCheckedCheckboxes = $('input[name=related-product]:checked');
    relatedFormCheckedCheckboxes.each((_, checkbox) => {
      if (isGiftGlassTopS && checkbox.value == glassTopVariantId) {
        items.push({'id': glassTopSVariantId});
        return true;
      }
      items.push({'id': checkbox.value});
    })
    // e-NRG追加
    let relatedFormSelectEnrgValue = document.getElementById('select_enrg');
    if (relatedFormSelectEnrgValue) {
      if (relatedFormSelectEnrgValue.value) {
        items.push({'id': relatedFormSelectEnrgValue.value});
      }
    }
    // アダプター追加
    let relatedFormSelectAdapter = document.getElementById('select_adapter');
    if (relatedFormSelectAdapter) {
      if (relatedFormSelectAdapter.value) {
        items.push({'id': relatedFormSelectAdapter.value});
      }
    }
    // 開梱設置追加
    let relatedFormSelectUnpackingValue = document.getElementById('select_unpacking');
    if (relatedFormSelectUnpackingValue) {
      if (relatedFormSelectUnpackingValue.value) {
        items.push({'id': relatedFormSelectUnpackingValue.value});
      }
    }
    // console.log(items)
    
    addItemsToCart({'items': items});
  })

  cartPopupCloseButton.click(function () {
    hideCartPopup();
  })
});